import Index from './components/Index'

export default [
  {
    path: '/upload',
    name: 'upload',
    component: Index
  },
]
